export default __webpack_public_path__ + "static/card-bg-b0d9eee15c0a031a465830e786cdcf2f.webp";